if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();

      this.mediaQuery = window.matchMedia("(max-width: 990px)");
    }

    initSlider() {
      if(this.slider) return;

      this.slider = new Flickity(this.querySelector('[js-slider]'), {
        pageDots: false
      });
    }

    destroySlider() {
      if(!this.slider) return;

      this.slider.destroy();
    }

    handleMediaQueryChange(event) {
      if(this.mediaQuery.matches) return this.initSlider();
      this.destroySlider();
    }

    connectedCallback() {
      this.mediaQuery.addEventListener("change", this.handleMediaQueryChange.bind(this));
      this.handleMediaQueryChange();
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}